import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cookie from 'universal-cookie';

import Modal from '@material-ui/core/Modal';

import ThemeStyle, {SECONDARY_BACKGROUND} from '../../theme-style';

import { getDisclaimerContents } from '../../../selectors/map';

import { closeDisclaimer } from '../../../actions/map-actions';

import styles from './disclaimer.scss';

class Disclaimer extends Component {
  doNotShowClick = () => {
    const cookie = new Cookie();
    cookie.set('disclaimerSeen', true, { path: '/' });
    this.props.closeDisclaimer();
  };

  render() {
    const cookie = new Cookie();
    const { disclaimer } = this.props;
    if (disclaimer && !cookie.get('disclaimerSeen')) {
      return (
        <Modal classes={{root: styles.modal}} disableBackdropClick open >
          <div className={styles.disclaimer}>
            <div className={styles.title}>Disclaimer</div>
            <div className={styles.contents}>{disclaimer}</div>
            <div className={styles.buttons}>
              <ThemeStyle
                style={SECONDARY_BACKGROUND}
                className={styles.seen}
                onClick={this.doNotShowClick}
              >
                <div>Do Not Show Again</div>
              </ThemeStyle>
              <ThemeStyle
                style={SECONDARY_BACKGROUND}
                className={styles.close}
                onClick={this.props.closeDisclaimer}
              >
                <div>OK</div>
              </ThemeStyle>
            </div>
          </div>
        </Modal>
      );
    }
    return null;
  }
}

Disclaimer.propTypes = {
  closeDisclaimer: PropTypes.func,
  disclaimer: PropTypes.string
};

const mapStateToProps = state => ({
  disclaimer: getDisclaimerContents(state)
});

export default connect(mapStateToProps, {closeDisclaimer})(Disclaimer);
